<script lang="ts">
  import Accordion from "@retailer/svelte/Cart/SavedForLater/Accordion.svelte";
  import Footer from "@retailer/svelte/Cart/SavedForLater/Footer.svelte";
  import type { SavedProductDict } from "@shared/types/SavedProducts";

  export let callbacks;
  export let cartService;
  export let isMobile: boolean = false;
  export let savedProducts: SavedProductDict;
  export let showLoading: boolean = false;
</script>

<div
  class="fizz-surface"
  class:fizz-inset-horizontal-48={!isMobile}
  class:fizz-inset-horizontal-16={isMobile}
  style="max-width: 1048px; margin: auto;"
>
  <div id="saved-for-later-section">
    <div class="fizz-flex-row fizz-space-between fizz-inset-vertical-24">
      <h2 class="fizz-heading-4">Saved for later</h2>
    </div>
    {#each Object.entries(savedProducts) as [distributorName, sp] (distributorName)}
      <div
        class="fizz-card fizz-bordered fizz-stack-16"
        data-testid="distributor-section-{distributorName}"
      >
        <Accordion
          {cartService}
          {callbacks}
          {distributorName}
          products={sp}
          {isMobile}
          bind:showLoading
        />
        <Footer {cartService} {distributorName} products={sp} {isMobile} bind:showLoading />
      </div>
    {/each}
  </div>
</div>
